import React from 'react';
import {changeNecklaceLength} from "../lib/actions";
import {connect} from "react-redux";
import {NECKLACELENGTH} from "../../constants";

class LengthToggle extends React.Component {
    render() {
        let id = 'radio-' + this.props.length.description;

        return (
            <>
                <input
                    checked={this.props.isActive}
                    id={id}
                    type="radio"
                    name="Length"
                    value={this.props.length.description}
                    onChange={(e) => this.props.onChange(this.props.length)}
                />
                <label htmlFor={id} className="product__swatch">
                    {this.props.length.description}
                </label>
            </>
        )
    }
}

class LengthSelector extends React.Component {
    render() {
        return (
            <div className='product__options'>
                <div className="product__length-option-name-container">
                    <h4 className="product__option-name">Length</h4>
                    <a href="/pages/necklace-size-guide" target="_blank">Size Guide</a>
                </div>
                <div className="product__swatch-container">
                    <LengthToggle isActive={this.props.selectedLength === NECKLACELENGTH.LENGTH15} length={NECKLACELENGTH.LENGTH15} onChange={this.props.onChange}/>
                    <LengthToggle isActive={this.props.selectedLength === NECKLACELENGTH.LENGTH18} length={NECKLACELENGTH.LENGTH18} onChange={this.props.onChange}/>
                    <LengthToggle isActive={this.props.selectedLength === NECKLACELENGTH.LENGTH21} length={NECKLACELENGTH.LENGTH21} onChange={this.props.onChange}/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedLength: state.necklaceLength,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (necklaceLength) => {
            dispatch(changeNecklaceLength(necklaceLength));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LengthSelector);
